export default class StudentsPlanningIndex {

  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    const stickyExamHeight = $("#sticky-exam").height() || 0;
    const navbarHeight = $("#navbar").height() || 0;
    
    if ($('.event-entry[data-done="true"]').length > 0) {
      const firstDayElement = $("#first-day");
      const targetOffset = firstDayElement.length > 0 
        ? firstDayElement.offset().top - stickyExamHeight - navbarHeight - 50 
        : $('.event-entry').last().offset().top - stickyExamHeight - navbarHeight - 50;
    
      $('html, body').animate({
          scrollTop: targetOffset
      }, 500);
    }
    
    $('#load-more-btn').on('click', () => this.loadMoreEntries());
  }

  loadMoreEntries() {
    let lastDate = $('.day-container').last().data('date');
    let url = $("#entries-container").data('url'); 

    // Add loading state
    $('#load-more-btn').addClass('loading');

    $.ajax({
      url: url,
      type: 'GET',
      data: { last_date: lastDate, check_future: true },
      dataType: 'html',
      success: (response) => {
        $('#entries-container').append(response); 
        // Check if the response includes data about future entries
        let hasFutureEntries = $('#entries-container').find('.has-future-entries').last().data('has-future');
        if (!hasFutureEntries) {
          $('#load-more-btn').hide();
        }
        // Remove loading state
        $('#load-more-btn').removeClass('loading');
      },
      error: () => {
        // Remove loading state on error
        $('#load-more-btn').removeClass('loading');
      }
    });
  }

  onDestroy() {
    // Clean up event handlers
    $('#load-more-btn').off('click');
  }
}